<script lang="ts" setup>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import type { User } from "~/models/User";
const { people } = useApi();

const user = defineModel<User>("user", { required: true });
</script>

<template>
    <UDropdown :items="people.dropdown(user)" :ui="{ width: 'w-48' }">
        <UButton
            color="white"
            icon="i-heroicons-ellipsis-horizontal-20-solid"
        />
        <template #item="{ item }">
            <div class="flex items-center gap-2" :class="item.class">
                <FontAwesomeIcon
                    :icon="item.icon"
                    class="flex-shrink-0 h-4 w-4 ms-auto"
                />
                <span class="truncate">{{ item.label }}</span>
            </div>
        </template>
    </UDropdown>
</template>
